var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.checkUserFeature("nav.settings.sections")
      ? _c("div", { attrs: { id: "notPermissions" } }, [
          _c("p", [_vm._v(_vm._s(_vm.$t("permissions")))]),
        ])
      : _c("div", [
          _c(
            "div",
            {
              staticClass: "feature card-item",
              attrs: { id: "search-container" },
            },
            [
              _c("Spinner", {
                attrs: { id: "spinner", "is-loading": _vm.isLoading },
              }),
              !_vm.showList && !_vm.isLoading
                ? _c(
                    "div",
                    { attrs: { id: "features-container" } },
                    [
                      _c(
                        "div",
                        { staticClass: "columns is-mobile my-0" },
                        [
                          _c(
                            "b-field",
                            { staticClass: "column", attrs: { expanded: "" } },
                            [
                              _c("b-taginput", {
                                attrs: {
                                  id: "section-filter-input",
                                  rounded: "",
                                  size: "is-small",
                                  data: _vm.filteredSectionTags,
                                  autocomplete: "",
                                  "allow-new": true,
                                  "open-on-focus": true,
                                  field: "feature.name22",
                                  placeholder: _vm.$t("sectionFilter"),
                                  "close-type": "is-success",
                                },
                                on: {
                                  typing: function ($event) {
                                    return _vm.getFilteredTags(
                                      "section",
                                      $event
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.sectionFilters,
                                  callback: function ($$v) {
                                    _vm.sectionFilters = $$v
                                  },
                                  expression: "sectionFilters",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            { staticClass: "column is-narrow" },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass:
                                    "is-primary is-light is-small is-rounded",
                                  attrs: {
                                    id: "back-button",
                                    "icon-left": "fa-solid fa-plus",
                                  },
                                  on: { click: () => _vm.createSection() },
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "is-size-7 has-text-weight-normal",
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("create")) + " "
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._l(_vm.sectionToShow, function (section) {
                        return _c(
                          "div",
                          {
                            key: section._id,
                            staticClass: "feature card-item shadowless",
                            attrs: { id: `section-${section._id}` },
                          },
                          [
                            _c("div", { staticClass: "feature-body" }, [
                              _c("div", { staticClass: "section-detail" }, [
                                _c("div", [
                                  _vm.checkExtended(section)
                                    ? _c(
                                        "div",
                                        [
                                          _c("b-input", {
                                            staticClass: "outlinenone",
                                            staticStyle: {
                                              "max-width": "300px",
                                            },
                                            attrs: {
                                              id: "input-name",
                                              size: "is-small",
                                            },
                                            model: {
                                              value: section.name,
                                              callback: function ($$v) {
                                                _vm.$set(section, "name", $$v)
                                              },
                                              expression: "section.name",
                                            },
                                          }),
                                          _c("b-input", {
                                            staticStyle: {
                                              "max-width": "300px",
                                            },
                                            attrs: { size: "is-small" },
                                            model: {
                                              value: section.description,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  section,
                                                  "description",
                                                  $$v
                                                )
                                              },
                                              expression: "section.description",
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _c("div", [
                                        _c(
                                          "p",
                                          {
                                            staticClass:
                                              "is-size-6 has-text-primary",
                                            attrs: { id: "sectionName" },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(section.name) + " "
                                            ),
                                          ]
                                        ),
                                        _c("p", { staticClass: "is-size-7" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(section.description) +
                                              " "
                                          ),
                                        ]),
                                      ]),
                                ]),
                                _c("div", { staticClass: "pt-1" }, [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        id: `gear-button-${section._id}`,
                                        href: "#",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.expandDetailSection(
                                            section
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c("span", {
                                        staticClass: "fa-solid fa-gear fa-xl",
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                              _vm.checkExtended(section)
                                ? _c(
                                    "div",
                                    { staticClass: "mt-4" },
                                    [
                                      _c("b-taginput", {
                                        staticClass: "mb-1",
                                        attrs: {
                                          id: `tag-section-${section._id}`,
                                          ellipsis: "",
                                          icon: "label",
                                          placeholder: _vm.$t("addTag"),
                                          size: "is-small",
                                        },
                                        model: {
                                          value: section.tags,
                                          callback: function ($$v) {
                                            _vm.$set(section, "tags", $$v)
                                          },
                                          expression: "section.tags",
                                        },
                                      }),
                                      _c("div", { staticClass: "mt-0" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "columns is-mobile my-0",
                                          },
                                          [
                                            _c(
                                              "b-field",
                                              {
                                                staticClass:
                                                  "column is-narrow mb-1",
                                                attrs: { expanded: "" },
                                              },
                                              [
                                                _c(
                                                  "b-select",
                                                  {
                                                    attrs: {
                                                      size: "is-small",
                                                      rounded: "",
                                                    },
                                                    on: {
                                                      input: function ($event) {
                                                        return _vm.onChangeSelectedSectionMode(
                                                          section
                                                        )
                                                      },
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.selectedSectionMode,
                                                      callback: function ($$v) {
                                                        _vm.selectedSectionMode =
                                                          $$v
                                                      },
                                                      expression:
                                                        "selectedSectionMode",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.sectionModeOptions,
                                                    function (option, i) {
                                                      return _c(
                                                        "option",
                                                        {
                                                          key: i,
                                                          domProps: {
                                                            value: option,
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                option ===
                                                                  "read"
                                                                  ? _vm.$t(
                                                                      "onlyRead"
                                                                    )
                                                                  : _vm.$t(
                                                                      "readWrite"
                                                                    )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "column" },
                                              [
                                                _c("b-taginput", {
                                                  attrs: {
                                                    id: "filter-user-features-input",
                                                    rounded: "",
                                                    size: "is-small",
                                                    data: _vm.userFeaturesTagList,
                                                    autocomplete: "",
                                                    "allow-new": true,
                                                    "open-on-focus": true,
                                                    field: "section.name22",
                                                    placeholder:
                                                      _vm.$t(
                                                        "userFeatureFilter"
                                                      ),
                                                    "close-type": "is-success",
                                                  },
                                                  on: {
                                                    typing: function ($event) {
                                                      return _vm.getFilteredTags(
                                                        "userFeature",
                                                        $event
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.userFeaturesFilter,
                                                    callback: function ($$v) {
                                                      _vm.userFeaturesFilter =
                                                        $$v
                                                    },
                                                    expression:
                                                      "userFeaturesFilter",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm.checkEmptySectionMode(section)
                                        ? _c(
                                            "p",
                                            {
                                              staticClass:
                                                "is-size-7 place-items: center",
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("addTagMessage")
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "div",
                                        [
                                          _vm._l(
                                            _vm.userFeaturesToShow,
                                            function (feature) {
                                              return _c(
                                                "div",
                                                {
                                                  key: feature.name,
                                                  staticClass:
                                                    "feature card-item shadowless green",
                                                  attrs: {
                                                    id: `feature-$.name}`,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "feature-body",
                                                    },
                                                    [
                                                      _c(
                                                        "b-field",
                                                        {
                                                          staticClass:
                                                            "check is-pulled-right",
                                                        },
                                                        [
                                                          _c("b-switch", {
                                                            attrs: {
                                                              id: `switch-${feature.name}-${feature.allowed}`,
                                                              type: "is-success",
                                                              size: "is-small",
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                return _vm.changeUserFeatureState(
                                                                  feature,
                                                                  section
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                feature.allowed,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    feature,
                                                                    "allowed",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "feature.allowed",
                                                            },
                                                          }),
                                                        ],
                                                        1
                                                      ),
                                                      feature.status
                                                        ? _c(
                                                            "b-field",
                                                            [
                                                              feature.status ===
                                                              "add"
                                                                ? _c(
                                                                    "b-tag",
                                                                    {
                                                                      staticClass:
                                                                        "mb-3",
                                                                      attrs: {
                                                                        type: "is-primary is-light",
                                                                        rounded:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "add"
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                              feature.status ===
                                                              "delete"
                                                                ? _c(
                                                                    "b-tag",
                                                                    {
                                                                      staticClass:
                                                                        "mb-3",
                                                                      attrs: {
                                                                        type: "is-danger is-light",
                                                                        rounded:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            _vm.$t(
                                                                              "delete"
                                                                            )
                                                                          ) +
                                                                          " "
                                                                      ),
                                                                    ]
                                                                  )
                                                                : _vm._e(),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                  feature.status !== "delete" &&
                                                  feature.status !== undefined
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "is-size-6 has-text-primary",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(feature.name)
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  feature.status === "delete" ||
                                                  feature.status === undefined
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "is-size-6 has-text-grey-light",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(feature.name)
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  feature.status !== "delete" &&
                                                  feature.status !== undefined
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "is-size-7 has-text-dark",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              feature.description
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  feature.status === "delete" ||
                                                  feature.status === undefined
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "is-size-7 has-text-grey-light",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              feature.description
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            }
                                          ),
                                          _c(
                                            "div",
                                            { staticClass: "pt-4 pb-6" },
                                            [
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "is-button-primary is-small is-rounded is-pulled-right",
                                                  attrs: {
                                                    id: "save-button",
                                                    disabled:
                                                      _vm.blockSave ||
                                                      !_vm.checkSectionChanges(
                                                        section
                                                      ),
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.applySectionsChanges(
                                                        section
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t("saveSection")
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              _c(
                                                "b-button",
                                                {
                                                  staticClass:
                                                    "is-text mr-4 pb-3 is-pulled-right",
                                                  attrs: {
                                                    id: "cancel-button",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.expandDetailSection(
                                                        section
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("span", [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "cancelSection"
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]),
                                                ]
                                              ),
                                              !_vm.confirmDelete
                                                ? _c(
                                                    "b-button",
                                                    {
                                                      staticClass:
                                                        "is-text mr-4 pb-3 is-pulled-left",
                                                      attrs: {
                                                        id: "ask-button",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.askConfirmDelete()
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("span", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              _vm.$t(
                                                                "deleteSection"
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]),
                                                    ]
                                                  )
                                                : _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "is-text mr-4 pb-3 is-pulled-left",
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "confirmDeleteSection"
                                                                )
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "is-button-primary is-small is-rounded is-pulled-left",
                                                          attrs: {
                                                            id: "delete-button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              _vm.deleteSection(
                                                                section
                                                              )
                                                              _vm.askConfirmDelete()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(" Si "),
                                                          ]),
                                                        ]
                                                      ),
                                                      _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "is-text mr-4 pb-3 is-pulled-left",
                                                          attrs: {
                                                            id: "ask-button",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.askConfirmDelete()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("span", [
                                                            _vm._v(" No "),
                                                          ]),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                            ],
                                            1
                                          ),
                                        ],
                                        2
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ]),
                          ]
                        )
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            1
          ),
        ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }